import { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { consLogged } from "../constants/consLogged";

import { verificaLogin } from "../context/actions/loginActions";
import { LayoutPage } from "../layout/LayoutPage";

import Login from "../views/auth/Login";
// import { Captura } from "../views/crearServicio/captura/Captura";
// import { CrearServicio } from "../views/crearServicio/CrearServicio";
import { CrearServiciosV2 } from "../views/crearServiciosV2/CrearServiciosV2";
import { EditarServicioV2 } from "../views/crearServiciosV2/EditarServicioV2";
import { DetalleServicio } from "../views/detalleServicio/DetalleServicio";
import { MapaDestino } from "../views/detalleServicio/mapaDestino/MapaDestino";

import { Home } from "../views/home/Home";
import { MisServicios } from "../views/misServicios/MisServicios";
import { Catch } from "../views/recursos/gnpApi/catch/Catch";
import { GnpApi } from "../views/recursos/gnpApi/GnpApi";
import { Recursos } from "../views/recursos/Recursos";
import { SemaforoFase1 } from "../views/semaforoHome/semaforo/Semaforo";
import { SemaforoFase2 } from "../views/semaforoHome/semaforoFase2/SemaforoFase2";
import { TodosServicios } from "../views/todosServicios/TodosServicios";
import { EvaluacionesPage } from "../views/evaluaciones/Evaluaciones";
import { NuevaEvaluacionPage } from "../views/evaluaciones/NuevaEvaluacion";
import { DetalleEvaluacionPage } from "../views/evaluaciones/DetalleEvaluacion";

//
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import ListadoChats from "../views/listadoChats/ListadoChats";
import { Carretero } from "../views/carretero/Carretero";

import { Spin } from "antd";
import { Library } from "../views/library/Library";
import { HdiApi } from "../views/hdiApi/HDIApi";
import { DetallesServicioHdi } from "../views/hdiApi/detallesHdiApi/DetallesServicioHdi";
import { SemaforoHome } from "../views/semaforoHome/SemaforoHome";
import { ProveedoresActivos } from "../views/proveedoesActivos/ProveedoresActivos";
import { SemaforoEscalamiento } from "../views/semaforoHome/semaforoEscalamiento/SemaforoEscalamiento";
import { SemaforoAsignacion } from "../views/semaforoHome/semaforoAsignacion/SemaforoAsignacion";
import { SemaforoSeguimiento } from "../views/semaforoHome/semaforoSeguimiento/SemaforoSeguimiento";
import { SemaforoAsignacionMonitor } from "../views/semaforoHome/semaforoAsignacionMonitor/SemaforoAsignacionMonitor";

export default function Routes() {
  const dispatch = useDispatch();
  const { logged } = useSelector((state) => state.userReducer);

  useEffect(() => {
    dispatch(verificaLogin());
  }, [dispatch]);

  if (logged === consLogged.INICIANDO) return <div>cargando...</div>;

  return (
    <Router>
      <div
        style={{
          height: "100vh",
          width: 15,
          backgroundColor: "#ca2228",
          position: "fixed",
          zIndex: 999,
        }}
      ></div>

      <Switch>
        <PublicRoute
          isAuthenticated={logged}
          exact
          path="/login"
          component={Login}
        />
        <LayoutPage>
          <Suspense
            fallback={
              <div style={{ marginTop: 30 }}>
                {" "}
                <Spin size="large" />
              </div>
            }
          >
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/"
              component={Home}
            />

            {/* <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/crearServicio"
              component={CrearServicio}
            /> */}
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/crearServicioV2"
              component={CrearServiciosV2}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/editarServicioV2/:asistenciaID"
              component={EditarServicioV2}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoFase1"
              component={SemaforoFase1}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoFase2"
              component={SemaforoFase2}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoHome"
              component={SemaforoHome}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoSeguimiento"
              component={SemaforoSeguimiento}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoEscalamiento"
              component={SemaforoEscalamiento}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoAsignacionMonitor"
              component={SemaforoAsignacionMonitor}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/semaforoAsignacion"
              component={SemaforoAsignacion}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/library"
              component={Library}
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/GnpApi"
              component={GnpApi}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/GnpApi/catch/:folioAsignacion"
              component={Catch}
            />

            {/* <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/captura/:campaniaID"
              component={Captura}
            /> */}

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/mapaDestino/:asistenciaID"
              component={MapaDestino}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/detalleAsistencia/:asistenciaID"
              component={DetalleServicio}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/misServicios"
              component={MisServicios}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/todosServicios"
              component={TodosServicios}
            />
            <Switch>
              <PrivateRoute
                isAuthenticated={logged}
                exact
                path="/evaluaciones"
                component={EvaluacionesPage}
              />
              <PrivateRoute
                isAuthenticated={logged}
                exact
                path="/evaluaciones/nueva"
                component={NuevaEvaluacionPage}
              />
              <PrivateRoute
                isAuthenticated={logged}
                exact
                path="/evaluaciones/:evaluacionId"
                component={DetalleEvaluacionPage}
              />
            </Switch>

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/recursos"
              component={Recursos}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/carretero"
              component={Carretero}
            />
            <PrivateRoute
              isAuthenticated={logged}
              component={ProveedoresActivos}
              exact
              path="/provedoresActivos"
            />
            <PrivateRoute
              isAuthenticated={logged}
              component={HdiApi}
              exact
              path="/hdiApi"
            />
            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/detallesHdiApi/:id"
              component={DetallesServicioHdi}
            />

            <PrivateRoute
              isAuthenticated={logged}
              exact
              path="/listadoChats"
              component={ListadoChats}
            />
          </Suspense>
        </LayoutPage>
      </Switch>
    </Router>
  );
}
